module.exports = __webpack_public_path__ + "static/img/header__copy.38a8973.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/simple/header__copy.png
// module id = 91qH
// module chunks = 1